module.exports = __webpack_public_path__ + "img/lifeline.ef2f6b0.png";